import { gql } from '@apollo/client';

export default gql`
  mutation confirmFreeUpgrade($bookingReference: String!, $currency: Currency!, $ticketNumbers: [String!]!) {
    confirmFreeUpgrade(bookingReference: $bookingReference, currency: $currency, ticketNumbers: $ticketNumbers) {
      reference
      totalPriceToBePaid
    }
  }
`;
